/* eslint-disable no-new */
/* eslint-disable vue/one-component-per-file */
import '../scss/norraskog.scss'
import { createApp, defineAsyncComponent } from 'vue'
import { copyButtons } from './components/_copy.js'
import { OnPageNav } from './components/_onpage-nav.js'

// import function to register Swiper custom elements

const pageInit = () => {
    if (document.getElementById('v-card')) {
        const VcardComp = defineAsyncComponent(() => import(/* webpackChunkName: "vcard-comp" */ './vue/components/contact/_contact-vcf-link.vue'))
        const app = createApp({
            components: {
                'v-comp': VcardComp
            }
        })
        app.mount('#v-card')
    }

    if (document.getElementById('mobilenav')) {
        const NavigationComp = defineAsyncComponent(() => import(/* webpackChunkName: "navigation-comp" */ './vue/components/_navigation.vue'))
        const app = createApp({
            components: {
                'v-comp': NavigationComp
            }
        })
        app.mount('#mobilenav')
    }

    if (document.querySelector('.splide--events')) {
        import(/* webpackChunkName: "event-slider" */ './components/_event-slider').then(module => {
            module.eventSlider()
        })
    }
    const videos = document.querySelectorAll('.video')

    if (videos?.length) {
        const Video = defineAsyncComponent(() => import(/* webpackChunkName: "video" */ './vue/components/video/_video.vue'))

        videos.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': Video
                }
            })
            app.mount(`#${el.id}`)
        })
    }

    const eventsCarousels = document.querySelectorAll('.events-carousel')

    if (eventsCarousels?.length) {
        const EventsCarousel = defineAsyncComponent(() => import(/* webpackChunkName: "eventscarousel" */ './vue/components/carousels/_eventscarousel.vue'))

        eventsCarousels.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': EventsCarousel
                }
            })
            app.mount(`#${el.id}`)
        })
    }

    const accordions = document.querySelectorAll('.accordion')

    if (accordions?.length) {
        const Accordion = defineAsyncComponent(() => import(/* webpackChunkName: "faqlist" */ './vue/components/faq/_faqlist.vue'))

        accordions.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': Accordion
                }
            })
            app.mount(`#${el.id}`)
        })
    }

    const documntLibrarys = document.querySelectorAll('.document-library')

    if (documntLibrarys?.length) {
        const DocumentLibrary = defineAsyncComponent(() => import(/* webpackChunkName: "documentlibrary" */ './vue/components/documentlibrary/_documentlibrary.vue'))

        documntLibrarys.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': DocumentLibrary
                }
            })
            app.mount(`#${el.id}`)
        })
    }

    const dropDowns = document.querySelectorAll('.dropdown-comp')

    if (dropDowns?.length) {
        const Dropdown = defineAsyncComponent(() => import(/* webpackChunkName: "dropdowncomp" */ './vue/components/dropdown/_dropdown.vue'))

        dropDowns.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': Dropdown
                }
            })
            app.mount(`#${el.id}`)
        })
    }

    const servicemodules = document.querySelectorAll('.service-module')

    if (servicemodules?.length) {
        const ServiceModule = defineAsyncComponent(() => import(/* webpackChunkName: "servicemodule" */ './vue/components/servicelisting/_servicemodule.vue'))

        servicemodules.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': ServiceModule
                }
            })
            app.mount(`#${el.id}`)
        })
    }

    new OnPageNav()

    /* Removes class for setting preheight on vueapps to prevent CLS in lighthouse */
    const vueMinHeight = document.querySelectorAll('.vue-min-height')

    if (vueMinHeight?.length) {
        vueMinHeight.forEach(el => {
            setTimeout(() => {
                el.classList.remove('vue-min-height')
            }, 500)
        })
    }
}

const pageLoad = () => {
    copyButtons()

    if (document.getElementById('mainsearch')) {
        const MainSearch = defineAsyncComponent(() => import(/* webpackChunkName: "norraskogsearch" */ './vue/components/search/_norraskog.vue'))
        const app = createApp({
            components: {
                'v-comp': MainSearch
            }
        })
        app.mount('#mainsearch')
    }

    if (document.getElementById('serviceListing')) {
        const ServiceListing = defineAsyncComponent(() => import(/* webpackChunkName: "servicelisting" */ './vue/components/servicelisting/_servicelisting.vue'))
        const app = createApp({
            components: {
                'v-comp': ServiceListing
            }
        })
        app.mount('#serviceListing')
    }

    if (document.getElementById('discountListing')) {
        const DiscountListing = defineAsyncComponent(() => import(/* webpackChunkName: "discountlisting" */ './vue/components/discountlisting/_discountlisting.vue'))
        const app = createApp({
            components: {
                'v-comp': DiscountListing
            }
        })
        app.mount('#discountListing')
    }

    if (document.getElementById('app-pressreleases')) {
        const Pressreleases = defineAsyncComponent(() => import(/* webpackChunkName: "pressreleases" */ './vue/components/pressreleases/_list.vue'))
        const app = createApp({
            components: {
                'v-comp': Pressreleases
            }
        })
        app.mount('#app-pressreleases')
    }

    if (document.getElementById('imageLibrary')) {
        const ImageLibrary = defineAsyncComponent(() => import(/* webpackChunkName: "imagelibrary" */ './vue/components/imagelibrary/_imagelibrary.vue'))
        const app = createApp({
            components: {
                'v-comp': ImageLibrary
            }
        })
        app.mount('#imageLibrary')
    }

    if (document.getElementById('faqList')) {
        const FaqList = defineAsyncComponent(() => import(/* webpackChunkName: "faqlist" */ './vue/components/faq/_faqlist.vue'))
        const app = createApp({
            components: {
                'v-comp': FaqList
            }
        })
        app.mount('#faqList')
    }

    if (document.getElementById('contactListing')) {
        const ContactListing = defineAsyncComponent(() => import(/* webpackChunkName: "contactListing" */ './vue/components/contact/_contactlisting.vue'))
        const app = createApp({
            components: {
                'v-comp': ContactListing
            }
        })
        app.mount('#contactListing')
    }

    // if (document.getElementById('contactSelectedListing')) {
    //    const ContactSelectedListing = defineAsyncComponent(() => import(/* webpackChunkName: "contactSelectedListing" */ './vue/components/contact/_contactselectedlisting.vue'))
    //    const app = createApp({
    //        components: {
    //            'v-comp': ContactSelectedListing
    //        }
    //    })
    //    app.mount('#contactSelectedListing')
    // }

    const contactSelectedListings = document.querySelectorAll('.contactSelectedListing')

    if (contactSelectedListings?.length) {
        const ContactSelectedListing = defineAsyncComponent(() => import(/* webpackChunkName: "contactSelectedListing" */ './vue/components/contact/_contactselectedlisting.vue'))

        contactSelectedListings.forEach(el => {
            const app = createApp({
                components: {
                    'v-comp': ContactSelectedListing
                }
            })
            app.mount(`#${el.id}`)
        })
    }

    const modalSearch = document.getElementById('modal-search')

    if (modalSearch) {
        import(/* webpackChunkName: "main-search" */ './components/_main-search').then(module => {
            module.mainSearch(modalSearch)
        })
    }
}

pageInit()
window.addEventListener('load', pageLoad)
